/**
 * Badge component for displaying status labels.
 *
 * Implementation plan reference: D2.15 - D2.18
 */

interface BadgeProps {
  variant: 'success' | 'warning' | 'error' | 'info' | 'neutral';
  children: React.ReactNode;
}

export function Badge({ variant, children }: BadgeProps): JSX.Element {
  return (
    <span className={`badge badge-${variant}`}>
      {children}
    </span>
  );
}
